import { Component, afterNextRender, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { environment } from '../environments/environment';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [RouterOutlet],
    templateUrl: './app.component.html'
})
export class AppComponent {
  title = 'pagos-ordenaris';

  private readonly document = inject(DOCUMENT);

  constructor() {
    afterNextRender(() => {
      const script = this.document.createElement('script');
      script.src = environment.paymentGateway;
      script.type = 'text/javascript';
      this.document.head.appendChild(script);
      script.async = true;

      // Se notifica al navegador cuando este cargado el plugin
      script.onload = () => {
        customElements.whenDefined('o-payment-gateway').then(() => {});
      };

      script.onerror = (error) => {
        console.error('Error cargando el script del payment gateway:', error);
      };

      this.document.head.appendChild(script);

    });
  }
}
